<template>
<div>
  <div id="data-list-list-view" class="data-list-container">
 <div>
      <vs-button class="user_add_btn" type="filled" @click.native="addNewData">
        <feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3"/>
        New Site
      </vs-button>
    </div>

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <upload-theme-sidebar :isSidebarActive="addNewThemeSidebar" @closeSidebar="toggleThemeSidebar" :data="sidebarThemeData" />


    <vs-table ref="table"  pagination :max-items="itemsPerPage" search :data="allpages">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->
          <!-- <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ pages.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : pages.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <!-- <vs-td>
                <p class="product-name font-medium truncate" @click="editPageContent(tr)">{{tr.charAt(0).toUpperCase()+tr.slice(1)}}</p>
              </vs-td> -->
              <vs-td>
                <p class="product-name font-medium truncate" >{{tr.name}}</p>
              </vs-td>            
               <vs-td class="whitespace-no-wrap">
                <vx-tooltip text="Preview" style="float: left">
                <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"  @click="viewPage(tr)"/>
                </vx-tooltip>
                 <vx-tooltip text="Edit" style="float: left">
                   <feather-icon icon="EditIcon" class="ml-1" svgClasses="w-5 h-5 hover:text-primary stroke-current"  @click="editData(tr)" />
                </vx-tooltip>
                <vx-tooltip text="Delete" style="float: left">
                <feather-icon icon="TrashIcon" class="ml-1" svgClasses="w-5 h-5 hover:text-danger stroke-current"  @click="confirmDeleteRecord(tr)"/>
                </vx-tooltip>
                <!-- <vx-tooltip text="Duplicate" style="float: left">
                <feather-icon icon="CopyIcon"  class="ml-1" svgClasses="w-5 h-5 hover:text-success stroke-current"  @click="copyPage(tr)"/>
                </vx-tooltip> -->
                <vx-tooltip text="Food Menu" style="float: left">
                  <img src="@/assets/images/pages/food.png" class="w-5 h-5" @click="gotoMenu(tr)">
                <!-- <feather-icon icon="CopyIcon"  class="ml-1" svgClasses="w-5 h-5 hover:text-success stroke-current"  @click="copyPage(tr)"/> -->
                </vx-tooltip>
                <vx-tooltip text="Upload Theme" style="float: left">
                <feather-icon icon="UploadIcon"  class="ml-1" svgClasses="w-5 h-5 hover:text-primary stroke-current"  @click="editTheme(tr)"/>
                </vx-tooltip>
              </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
    <div class="demo-alignment">
    <vs-popup classContent="popup-example" title="Duplicte File" :active.sync="copyPopup">
      <vs-input class="inputx mb-3 w-full" placeholder="Name"  label="Name *" v-model="copyName"/>
      <vs-input disabled class="inputx mb-3 w-full" placeholder="Disabled"  label="Duplicte From"  v-model="currentWebPage"/>
      <vs-button style="float:right" @click.native="createCopyPage()" :disabled="!isFormValid">Save</vs-button>
    </vs-popup>
  </div>
</div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import UploadThemeSidebar from './theme/UploadThemeSidebar.vue'
import { GET_ALL_SITES,GET_PAGE_CONTENT,DELETE_WEB_PAGE,COPY_WEB_PAGE } from "@/graphql";
export default {
  name: 'Pages',
   components: {
    DataViewSidebar,
    UploadThemeSidebar
  },
   data() {
    return {
     pages:[],
      itemsPerPage: 10,
       selected: [],

      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      addNewThemeSidebar: false,
      sidebarData: {},
      sidebarThemeData: {},
      currentWebPage:null,
      copyPopup:false,
      copyName:null
    }
  },

  computed:{
      currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    allpages () {
      return this.pages
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.pages.length
    },
     isFormValid () {
      return !this.errors.any() && this.copyName && this.currentWebPage
    },

  },
  methods:{
    gotoMenu(item){
      this.$router.push('food/'+item.name)
    },
    confirmDeleteRecord (site) {
      this.currentWebPage=site.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete . This site will be permanent delete from server`,
        accept: this.deletePage,
        acceptText: 'Delete'
      })
    },
     alertNofity (color,text) {
      this.$vs.notify({
        color: color,
        title: "Page",
        position: 'top-right',
        text: text
      })
    },
    viewPage(page){
      this.$router.push('/site/'+ page.name +'/home')
      //  window.open('https://dev3.barqsol.com/basic/'+page, '_blank');
    },
    createCopyPage(){
       if(this.currentWebPage && this.copyName){
           this.$apollo
          .mutate({
            mutation: COPY_WEB_PAGE,
            variables: {
              page:this.currentWebPage,
              name:this.copyName
            }
          })
          .then(response => {
            if(response.data.copyWebPage.status==='Success'){
                 this.copyName=null
                 this.copyPopup=false
                 this.currentWebPage=null
              this.alertNofity(response.data.copyWebPage.color,response.data.copyWebPage.message)
              this.get()
            }
            else{
              this.alertNofity(response.data.copyWebPage.color,response.data.copyWebPage.message)
            }
          }).catch(error => {
            console.log(error)
          })
       }
    },
    copyPage(page){
     this.copyName=null
     this.copyPopup=true
     this.currentWebPage=page
    },
    deletePage(){
        this.$apollo
          .mutate({
            mutation: DELETE_WEB_PAGE,
            variables: {
              page:this.currentWebPage
            }
          })
          .then(response => {
            if(response.data.deleteWebPage.status==='Success'){
              this.alertNofity(response.data.deleteWebPage.color,response.data.deleteWebPage.message)
              this.get()
            }
            else{
              this.alertNofity(response.data.deleteWebPage.color,response.data.deleteWebPage.message)
            }
          }).catch(error => {
            console.log(error)
          })
    },
    getdata(){
         this.get()
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addNewTheme () {
      this.sidebarThemeData = {}
      this.toggleThemeSidebar(true)
    },
    deleteData (id) {
      this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    editTheme (data) {
      this.sidebarThemeData = data
      this.toggleThemeSidebar(true)
    },
      toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleThemeSidebar (val = false) {
      this.addNewThemeSidebar = val
    },
    editPageContent(page){
      this.$router.push('/grapesjs/'+page)
    },
    getPageContent(page){
          this.$apollo
          .mutate({
            mutation: GET_PAGE_CONTENT,
            variables: {
              page:page
            }
          })
          .then(response => {
            this.view=response.data.getPageContent.template
          }).catch(error => {
            console.log(error)
          })
    },
    get(){
      this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", 'vertical');
     this.$apollo
      .mutate({
        mutation: GET_ALL_SITES,
      })
      .then((response) => {
        console.log(response)
        this.pages=response.data.allSites
      })
      .catch((error) => {
        console.log(error);
      });
    }
  },
   mounted () {
    this.isMounted = true
  },
  created(){
    this.get()
  }
}
</script>
<style lang="scss">
//.con-vs-popup .vs-popup{
//  width:50% !important;
//}
#data-list-list-view {
  .user_add_btn {
    float: right;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }

  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }

  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

